// import { getCaptchaResult } from "../../../src/utilities/auth.helper";

const envSettings = {
    serviceEndPoints: {
        login: 'cls/login/CATCmaUserAthenticationServlet/login',
        validateVoucherUid:
            'cls/login/CATCmaUserAthenticationServlet/validateVoucherUid',
        zones: 'cls/newui/CATCmaDashboardServlet/getUserPreferences',
        forgotPass: 'cls/login/CATCmaUserAthenticationServlet/forgotPassword',
        submitContact: 'cls/login/CATCmaUserAthenticationServlet/contactus',
        getPublicLibraries: 'cls/newui/CATCmaCourseSearchServlet/getPublicLibraries',
        getPublicSearchCatalog: 'cls/newui/CATCmaCourseSearchServlet/getPublicCourses',
        getDSPUrl: 'cls/newui/CATCmaCourseSearchServlet/getDSPUrl',
        getCaptchaValue: 'cls/login/CATCmaUserAthenticationServlet/generateCaptcha'
        // getCaptchaValue: '../voucher.json'
    },
    clsUrls: {
        adminUrl: 'catcma/ui/secure/CATCmaWelcomePageAdmin.xhtml',
        teacherUrl: 'catcma/ui/secure/CATCmaWelcomePageTeacher.xhtml',
        studentUrl: 'ui/#/user/',
        authorUrl: 'ui/#/author/authordashboard',
        termOfUseUrl: 'ui/#/termsOfUse',
        changePwdUrl: 'ui/#/changePassword',
        assignmentUrl: 'ui/#/assignments',
        errorLink: 'ui/#/errorLink',
        pdfDownload: 'ui/#/pdfDownload',
        inAccessibleLinkUrl: 'catcma/ui/CATCmaInAccessibleLinkErrorPage.xhtml',
        coursewareDownloadUrl:
            'catcma/ui/secure/CATCmaCoursewareDownload.xhtml',
        search: '/ui/#/search/',
        publicPage: '/public/#',
        course: '/ui/#/course/',
        coursePublicMeta:
            '/TODO:%20No%20launch%20message%20for%20me./false/false/home////',
        publicSearch: '/ui/#/user/catalog'
    },
    voucherSettings: {
        controllerUrl: 'CATWebSrvCommandFrontController',
        actionParam: 'catwebsrv_action',
        uuidParam: 'catwebsrv_vuid',
        initActionParam: 'catwebsrv_init_action'
    },
    upUrls: {
        upApp: '/up'
    }
};

export default envSettings;
